module.exports = __webpack_public_path__ + "static/media/seat-bg-smoke.2a056839.png";